import React from 'react'
import './Advfour.css'
import { Link } from 'react-router-dom';

function Advfour() {
    return (
        <div>
                    <div className="advone">
            <div className="advone_header">
            Upgrade your home | Amazon Brands & more
            </div>
            <div className="advone_body">
                <img src=".\amazon-image\box1_1.jpg" width="300px" className="advfourimg" />
                <img src=".\amazon-image\box1_2.jpg" width="300px" className="advfourimg" />
                <img src=".\amazon-image\box1_3.jpg" width="300px" className="advfourimg" />
                <img src=".\amazon-image\box1_4.jpg" width="300px" className="advfourimg" />
                
              
            </div>
            <Link to ="/electronics">
            <div className="advone_footer">
                See more
            </div>
             </Link>
        </div>  
        </div>
    )
}

export default Advfour
